import environment from '#/environment/environment';
import {Land, UnlistedLand} from '@shareland/shareland-common';

export const landHasMarket = (neighbourhood: UnlistedLand | undefined): neighbourhood is Land => {
  return !!neighbourhood && (neighbourhood as Land).contractAddresses !== undefined;
};

export const landThumbnailUrl = (land: Land) => {
  return `${environment.assetUrl}/land-thumbnails/${land.tokenSymbol.toLocaleLowerCase()}.jpg`;
};

export const landShapeUrl = (land: Land) => {
  return `${environment.assetUrl}/land-shapes/${land.tokenSymbol.toLocaleLowerCase()}.svg`;
};
